import styled from '@emotion/styled'
import { calcRem, metrics } from '../../__styling'

// TheNightly Metrics
const tnMetrics = metrics.thenightly
const tnMargins = tnMetrics.margins

export const StyledLabel = styled('label')<{ size?: number; width?: string }>(
    ({ size = tnMargins.md, width, theme }) => ({
        width: width ?? undefined,
        fontFamily: theme.fonts.sansSerif,

        display: 'flex',
        '& + &': {
            marginLeft: 0,
            marginTop: calcRem(tnMargins.md),
        },

        input: {
            marginRight: calcRem(tnMargins.sm),
            marginLeft: calcRem(tnMargins.sm),

            height: calcRem(size),
            width: calcRem(size),
        },
    }),
)
